// extracted by mini-css-extract-plugin
export default {"cardTitle":"title_cardTitle__0SY9K"};